<script lang="ts" setup>
import InputFieldHeader from '@/components/atoms/InputFieldHeader/InputFieldHeader.vue'
import { computed, onMounted } from 'vue'
const props = defineProps<{
    modelValue?: boolean
    label?: string
    helpText?: string
    placeholder?: string
    required?: boolean
   defaults: { [propertyName: string]: string | null | undefined };
 

}>()
const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void
}>()
const isChecked = computed({
    get: () => {
        return props.modelValue ?? false
    },
    set: (value: boolean) => {
        emit('update:modelValue', value)
    }
})

onMounted(() => {
    if (props.defaults && props.defaults.Checked?.toLowerCase().includes("true")) {
        isChecked.value = true;
    }
})
</script>
<template>
      <InputFieldHeader v-if="helpText || label" :help-text="helpText"
        :required="required" :label="label" />
    <label class="checkbox fw-normal">
        <input
            type="checkbox"
            v-model="isChecked"
        />
        <span class="checkbox__mark fs-1"></span>
        {{ placeholder }}
    </label>
</template>
<style lang="scss" scoped>
.checkbox {
    display: inline-flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    font-size: rem(16);
    font: $font-weight-normal;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    [type='checkbox'] {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
        border: none;
    }

    [type='checkbox']:checked ~ .checkbox__mark {
        background-color: $dn-yellow;
        border-color: $dn-yellow;
    }
    [type='checkbox']:checked ~ .checkbox__mark::after {
        visibility: visible;
    }

    &__mark {
        left: 0;
        height: rem(40);
        width: rem(40);
        min-width: rem(40);
        min-height: rem(40);
        background-color: $gray-100;
        border: 1px solid $gray-200;
        margin-right: 1rem;
        display: flex;
        justify-content: center;
        padding: rem(5);

        &::after {
            content: '';
            display: block;
            visibility: hidden;
            width: 12px;
            height: 21px;
            border: solid $dn-blue;
            transform-origin: center;
            border-width: 0 3px 3px 0;
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
        }
    }

    &:hover .checkbox__mark {
        background-color: $gray-200;
    }
}

 .mineture-tidtiltur-dk{

    .checkbox {
        input{
            border: none !important;
        }
        span {
            border: none !important;
        }
    }
}   


 .localhost, .events-naturensuge-dk  {
    .checkbox {

    [type='checkbox']:checked ~ .checkbox__mark {
        background-color:$dn-naturensuge-let;
  //      border-color: $dn-naturensuge-let;
    }
      &__mark {
        left: 0;
        height: rem(40);
        width: rem(40);
        min-width: rem(40);
        min-height: rem(40);
        background-color: lightgray;
        border: 1px solid gray;
        margin-right: 1rem;
        display: flex;
        justify-content: center;
        padding: rem(5);

    }}
}
</style>
